const initialState = {
    barcode: '', // input
    mobile: '', // input
    code: '', // input
    barcodeBtnDisable: false, 
    sendSmsBtnDisable: false,
    sendSmsBtnTxt: 'ارسال کد', 
    smsBtnDisable: false, 
    fullname: '', 
    nationalCode: '',
    userCredit: 0, 
    normalCredit: 0, 
    orgCredit: 0,
    service: '', // input select
    cartAmount: '', // input
    shopShare: '', // input
    cashBackAmount: '', // input
    trackingNum: '', // input
    factorNum: '', // input
    description: '', // input
    addTransBtnDisable: false, 
    userMobile: '', 
    userCode: '',
    timeRemaining: 0, // zamani ke code karbar ra ersal kardim va 2 min vaght darim etelate sabte tarkonesh ra por konim
    timerTimeAgain: 0, // zamani ke zadim ersale code ba sms, chand saniye digar mishavad ersale mojadad zad  
    warningWalletShow : false, 
    requiredSpanShow : false, 
    warningChargeShow : false, 
    chargeAmountTxt : '', 
    visibleSuccessMsg: false,
};

const addTrans = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_ADD_TRANS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default addTrans;
